import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CircleIcon from '@mui/icons-material/Circle';
import CommentIcon from '@mui/icons-material/Comment';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import DoneAllSharpIcon from '@mui/icons-material/DoneAllSharp';
import EditIcon from '@mui/icons-material/Edit';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import WorkIcon from '@mui/icons-material/Work';
import { TimelineItem } from '@mui/lab';
import {
  ListItemButton,
  Box,
  Grid,
  Card,
  IconButton,
  Chip,
  Link,
  Typography,
  styled,
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { FaLinkedin } from 'react-icons/fa';
import {
  MdOutlineBusiness,
  MdOutlineInfo,
  MdOutlineLocationOn,
  MdOutlinePeople,
  MdOutlinePhone,
  MdOutlineSource,
} from 'react-icons/md';
import { Link as RouterLink, useParams, useSearchParams } from 'react-router-dom';
import {
  updateClientContactStatus,
  LogAction,
  LogContextType,
  LogEntityType,
  saveActivityLog,
  ClientContactDTO,
  getClientContactById,
  getActivityLogs,
  getActivityLogsByEntity,
  ActivityLogDTO,
  assignDncDetails,
  DncDetailsDTO,
} from 'wisestep-api';
import {
  getFormatDate,
  WsColors,
  WsIconText,
  WsTypoColors,
  WsTypoVariants,
  ScrollableButtonTabs,
  WsTypography,
  WsTimeLine,
  WsIconMoreVer,
  formatDateInDayMonthYearTime,
  WsDrawer,
  WsDotIcon,
  WsDotColors,
  WsDotTextColors,
} from 'wisestep-base';

import { AccessControl } from '../../../../components';
import { NotesParent } from '../../../../components/communicationBar/Notes';
import { IBreadCrumbsList, WsBreadCrumbs } from '../../../../components/WsBreadCrumbs';
import CircularImage from '../../../../components/WsCustomImage/CircularImage';
import { WsTabs } from '../../../../components/WsTabs';
import { useWorkspaceContext } from '../../../../context/WorkspaceContext';
import {
  WsActivityProps,
  activityLogDTOHelper,
} from '../../../../features/activityLog/ActivityHelper';
import ComposableDashboardFiltersContextProvider from '../../../../features/analyticsPage/context/ComposableDashboardFiltersContext';
import { getFile } from '../../../../features/careerPageSettings/util';
import ClientContacts from '../../../../features/clientListingPage/components/ClientContacts';
import ClientOwnerPopUp from '../../../../features/clientListingPage/components/ClientOwnerPopUp';
import PopoverOnClick from '../../../../features/clientListingPage/components/PopoverOnClick';
import { buildLeadUrlFromId } from '../../../../features/clientListingPage/helper/ClientListingHelper';
import { useActiveLeadStatus } from '../../../../features/clientsSettings/hooks/useActiveLeadStatus';
import DataPrivacy from '../../../../features/conversationWidget/components/DataPrivacy';
import UserProfileOverview from '../../../../features/recruiterProfileDetails/components/userProfile/UserProfileOverview';
import { useClientAuthz, ClientAction } from '../../../../hooks/useClientAuthz';
import { useDialog } from '../../../../hooks/useDialog';
import { useDrawer } from '../../../../hooks/useDrawer';
import getEncodedQueryParams from '../../../../utils/getEncodedQueryParams';
import { failed } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { openUrlInNewTab } from '../../../../utils/openUrlInNewTab';
import { defaultQuery } from '../../../jobs/listing/JObSearchFilterDefaultQuery';
import {
  ClientDetailsParams,
  ClintPageBreadCrumb,
  clientContactLayoutTabNames,
  clientsAmplitudeEvents,
  getClientOrContactListBreadCrumbs,
  limitedPrivacyOptions,
} from '../../helper/clientDetailsHelper';
import openNotesFormDialog from '../../helper/openNotesFormDialog';
import CandidateTags from '../CandidateTags';
import ClientSharingTable from '../clientSharing';
import DocumentsTab from '../documentsTab/DocumentsTab';
import ComposeNote from '../notes/ComposeNote';
import { notesAmplitudeEvents } from '../notes/helper/notesHelper';

const StyledChip = styled(Chip)(() => ({
  color: WsColors.White,
  backgroundColor: WsColors.Red500,
  borderRadius: 1,
  fontWeight: 'bold',
  fontSize: 14,
}));

const ClientContactDetails = () => {
  const params = useParams<ClientDetailsParams>();
  const [param] = useSearchParams();
  const isChild: boolean = param.get('isChild') === 'true';
  const parentName: string = param.get('name') ?? '';
  const [openDrawer, closeDrawer] = useDrawer();
  const [clientContactInfo, setClientContactInfo] = useState<ClientContactDTO>();
  const setNotification = useNotificationStore((state) => state.setNotification);
  const isAuthorizedViewAnalytics = useClientAuthz(ClientAction.VIEW_ANALYTICS);
  const isAuthorizedEditContact = useClientAuthz(ClientAction.EDIT_VIEW_USER_CONTACT_DETAILS);
  const isAuthorizedAddContact = useClientAuthz(ClientAction.ADD_ASSIGN_CLIENT_CONTACT);
  const [parentTabIndex, setParentTabIndex] = useState<number>(0);
  const [getActivityData, setgetActivityData] = useState<ActivityLogDTO[]>([]);
  const [openDialog, closeDialog] = useDialog();
  const workspace = useWorkspaceContext();
  const isInDnc = clientContactInfo?.dncDetails?.isInDnc ?? false;
  const [openDNC, setOpenDNC] = useState<boolean>(false);
  const [openClientOwnerFormDialog, setOpenClientOwnerFormDialog] = useState<boolean>(false);
  const activeStatus = useActiveLeadStatus();
  const [contactImageUrl, setContactImageUrl] = useState<string | null>(null);

  const handleClientContactStatus = async (id: string, markStatus: boolean, firstName: string) => {
    clientsAmplitudeEvents(
      'contact_details_status_update',
      'Contact Details Status Update',
      workspace
    );
    await updateClientContactStatus(id, markStatus);
    const avPayload = { ...activityLogDTOHelper };
    avPayload.action = LogAction.Edit;
    avPayload.description = `Marked status as ${
      markStatus === true ? 'Active' : 'Inactive'
    } for ${firstName} Client Contact under`;
    avPayload.parentEntitiyType = LogContextType.Client;
    avPayload.entityType = LogEntityType.ClientContact;
    avPayload.entityId = id;
    avPayload.parentEntitiyId = clientContactInfo?.clientId ?? '';
    avPayload.field = `Client Contact`;
    avPayload.contextData = { clientId: clientContactInfo?.clientId ?? '' };
    await saveActivityLog(avPayload);
    getClientContact();
  };

  const onNavigateToJobs = async (email: string) => {
    clientsAmplitudeEvents('contact_details_jobs', 'Contact Details Jobs', workspace);
    openUrlInNewTab(
      `/jobs?d=${getEncodedQueryParams({
        ...defaultQuery,
        clientList: [{ name: parentName }],
        clientRecruiterList: [{ emailAddress: email ?? '' }],
      })}`
    );
  };

  const getClientContact = useCallback(async () => {
    if (params.id !== undefined) {
      try {
        const response = await getClientContactById(params.id as string);
        if (response?.data?.data) {
          const contactData = response.data.data;
          const updatedContactData = {
            ...contactData,
            supervisorName: contactData.supervisor
              ? `${contactData.supervisor.firstName} ${contactData.supervisor.lastName}`
              : '',
            supervisorPosition: contactData?.supervisor?.position ?? '',
            tags: contactData?.tags ?? [],
          };
          setClientContactInfo(updatedContactData);
          const fileUrl =
            updatedContactData.imageUrl && (await getFile(updatedContactData.imageUrl));
          fileUrl && setContactImageUrl(fileUrl);
        }
      } catch {
        setNotification(failed(`Failed to fetch Client Contact Information`));
      }
    } else setNotification(failed(`Id not found in the url`));
  }, [params.id, setNotification]);

  useEffect(() => {
    getClientContact();
  }, [getClientContact]);

  const activityLists: WsActivityProps[] = [];

  useEffect(() => {
    let avtivityLog: any = [];
    const fetchDataLog = async () => {
      if (clientContactInfo?.clientId) {
        try {
          const { data: actvityResponseContext } = await getActivityLogs(
            clientContactInfo?.clientId ?? ''
          );
          const { data: actvityResponseEnitiy } = await getActivityLogsByEntity(
            clientContactInfo?.clientId ?? ''
          );
          avtivityLog = actvityResponseContext.concat(actvityResponseEnitiy);
          setgetActivityData(avtivityLog);
        } catch {
          setNotification(failed(`Failed to fetch company Information`));
        }
      }
    };
    fetchDataLog();
  }, [clientContactInfo?.clientId, setNotification]);

  getActivityData
    ?.filter(
      (data: ActivityLogDTO) =>
        data.field === 'Client Contact' && data.entityId == (params.id as string)
    )
    .map((data: ActivityLogDTO) =>
      activityLists.push({
        activity: (
          <TimelineItem>
            <Grid container>
              <Grid item xs={12}>
                <WsTypography color={WsTypoColors.TERTIARY}>
                  {` At ${formatDateInDayMonthYearTime(data?.createdOn?.toString())} by ${
                    data.createdByName
                  }`}
                </WsTypography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant={WsTypoVariants.SUB_TITLE}>
                  {`${data.field} Category -> ${data.description} client ${data.parentEntitiyName}`}
                </Typography>
              </Grid>
            </Grid>
          </TimelineItem>
        ),
        leftChildren: <CircleIcon sx={{ color: WsColors.TheBlues600 }} fontSize={'small'} />,
      })
    );

  const fullName = clientContactInfo?.firstName
    ? clientContactInfo.lastName
      ? clientContactInfo.firstName + ' ' + clientContactInfo.lastName
      : clientContactInfo.firstName
    : clientContactInfo?.lastName;

  const breadCrumbsList: IBreadCrumbsList[] = getClientOrContactListBreadCrumbs(
    param,
    fullName,
    'CLIENT_CONTACTS'
  );
  const handleOpenDrawer = () => {
    clientsAmplitudeEvents('contact_details_assign', 'Contact Details Assign', workspace);
    openDrawer({
      children: (
        <ClientSharingTable
          clientId={clientContactInfo?.clientId ?? ''}
          moduleName="CLIENT-CONTACT"
          clientContactId={clientContactInfo?.id ?? ''}
        />
      ),
      size: 'small',
      title: 'Client Contacts Access',
    });
  };

  const handleOpenClientContactsDrawer = () => {
    clientsAmplitudeEvents('contact_details_edit', 'Contact Details Edit', workspace);
    openDrawer({
      children: (
        <ClientContacts
          clientId={clientContactInfo?.clientId ?? ''}
          showSavedData={false}
          clientContactForEdit={clientContactInfo}
          closeOnUpdate={() => closeDrawer()}
        />
      ),
    });
  };

  const handleOpenNotesDialog = () => {
    clientsAmplitudeEvents('contact_details_note_add', 'Contact Details Note Add', workspace);
    openNotesFormDialog({
      clientId: clientContactInfo?.clientId ?? '',
      contactId: clientContactInfo?.id ?? '',
      clientName: clientContactInfo?.firstName,
      contactName: clientContactInfo?.firstName,
      isClient: false,
      openDialog: openDialog,
      closeDialog: closeDialog,
    });
  };

  const handleTabIndexChange = (index: number) => {
    const tabs = clientContactLayoutTabNames();
    tabs?.[index].tabName === 'Activity' &&
      notesAmplitudeEvents(
        isChild ? 'note_contact' : 'note_child_contact',
        isChild ? 'Note Contact' : 'Note Child Contact',
        workspace
      );
    setParentTabIndex(index);
    clientsAmplitudeEvents(
      `contact_details_${tabs?.[index].tabName?.toLowerCase()}`,
      `Contact Details ${tabs?.[index].tabName}`,
      workspace
    );
  };

  const handleDncSubmit = async (contactId: string, data: DncDetailsDTO) => {
    try {
      await assignDncDetails(contactId, data);
    } catch (error) {
      console.error('Error updating DNC details / lead status:', error);
    }
  };

  return (
    <>
      <WsBreadCrumbs breadCrumbsList={breadCrumbsList ?? []} maxItems={4} />
      {clientContactInfo && (
        <Box borderRadius={2}>
          <Card
            sx={{
              borderRadius: 4,
              px: 1,
              py: 2,
              backgroundColor: WsColors.TheBlues900,
            }}
          >
            <Grid container display="flex" flexDirection="row">
              <Grid item xs={0.5} ml={6} alignItems="center">
                <CircularImage src={contactImageUrl ?? ''} />
              </Grid>
              <Grid item xs={11}>
                <Grid container direction="row" alignItems="center" spacing={1}>
                  <Grid item>
                    <WsTypography
                      variant={WsTypoVariants.TITLE}
                      color={WsTypoColors.WHITE}
                      cursor="pointer"
                    >
                      {fullName}
                    </WsTypography>
                  </Grid>
                  <Grid item>
                    {clientContactInfo?.linkedinProfile && (
                      <IconButton
                        onClick={() =>
                          window.open(clientContactInfo?.linkedinProfile ?? '', '_blank')
                        }
                      >
                        <FaLinkedin color={WsColors.White} />
                      </IconButton>
                    )}
                  </Grid>
                  <>
                    {isInDnc && (
                      <Grid item ml={2}>
                        <StyledChip label="Do Not Contact" color="primary" size="small" />
                      </Grid>
                    )}
                  </>

                  {!isInDnc && (
                    <Grid item>
                      <Chip
                        label={clientContactInfo?.markStatus ? 'Active' : 'Inactive'}
                        color="primary"
                        sx={{
                          color: WsColors.White,
                          borderRadius: 1,
                          fontWeight: 'bold',
                          fontSize: 14,
                        }}
                        size="small"
                      />
                    </Grid>
                  )}
                  {clientContactInfo.activeLeadCount && (
                    <>
                      <Grid item justifyContent="center">
                        <WsDotIcon
                          color={WsDotColors.WHITE}
                          textColor={WsDotTextColors.WHITE}
                          value={''}
                        />
                      </Grid>
                      <Grid item>
                        <Link
                          underline="hover"
                          key="1"
                          href={buildLeadUrlFromId(
                            clientContactInfo?.id ?? '',
                            activeStatus,
                            'contact'
                          )}
                        >
                          <WsTypography
                            variant={WsTypoVariants.SUB_TITLE}
                            bold
                            color={WsTypoColors.PRIMARY}
                            cursor="pointer"
                          >
                            View Lead(s)
                          </WsTypography>
                        </Link>
                      </Grid>
                    </>
                  )}
                  <Grid item sx={{ ml: 'auto' }}>
                    <PopoverOnClick element={<WsIconMoreVer />}>
                      <Grid
                        p={1}
                        sx={{
                          backgroundColor: WsColors.TheBlues900,
                        }}
                      >
                        <ListItemButton>
                          <WsIconText
                            text="Create Note"
                            textCursor="pointer"
                            icon={
                              <EventNoteIcon
                                sx={{ height: '23', width: '23', color: WsColors.White }}
                              />
                            }
                            textColor={WsTypoColors.PRIMARY}
                            onClick={handleOpenNotesDialog}
                          />
                        </ListItemButton>
                        {isAuthorizedAddContact && !isInDnc && (
                          <ListItemButton>
                            <WsIconText
                              textCursor="pointer"
                              icon={
                                <PersonAddAltOutlinedIcon
                                  sx={{ height: '25', width: '25', color: WsColors.White }}
                                />
                              }
                              textColor={WsTypoColors.PRIMARY}
                              text="Assign user"
                              onClick={handleOpenDrawer}
                            />
                          </ListItemButton>
                        )}
                        {!isInDnc && (
                          <ListItemButton>
                            <WsIconText
                              text={`Mark as ${
                                clientContactInfo?.markStatus ? 'Inactive' : 'Active'
                              }`}
                              textCursor="pointer"
                              icon={
                                <DoneAllSharpIcon
                                  sx={{ height: '23', width: '23', color: WsColors.White }}
                                />
                              }
                              textColor={WsTypoColors.PRIMARY}
                              onClick={() =>
                                handleClientContactStatus(
                                  clientContactInfo?.id ?? '',
                                  clientContactInfo?.markStatus == true ? false : true,
                                  clientContactInfo?.firstName
                                )
                              }
                            />
                          </ListItemButton>
                        )}
                        <ListItemButton>
                          <WsIconText
                            text="Jobs"
                            textCursor="pointer"
                            icon={
                              <WorkIcon sx={{ height: '23', width: '23', color: WsColors.White }} />
                            }
                            textColor={WsTypoColors.PRIMARY}
                            onClick={() => onNavigateToJobs(clientContactInfo.emailAddress)}
                          />
                        </ListItemButton>
                        {isAuthorizedEditContact && !isInDnc && (
                          <ListItemButton>
                            <WsIconText
                              text="Edit"
                              textCursor="pointer"
                              icon={
                                <EditIcon
                                  sx={{ height: '23', width: '23', color: WsColors.White }}
                                />
                              }
                              textColor={WsTypoColors.PRIMARY}
                              onClick={handleOpenClientContactsDrawer}
                            />
                          </ListItemButton>
                        )}
                        <ListItemButton>
                          <WsIconText
                            text="Update Owner"
                            textCursor="pointer"
                            icon={
                              <PersonIcon
                                sx={{ height: '23', width: '23', color: WsColors.White }}
                              />
                            }
                            textColor={WsTypoColors.PRIMARY}
                            onClick={() => setOpenClientOwnerFormDialog(true)}
                          />
                        </ListItemButton>
                        <ListItemButton>
                          <WsIconText
                            text={!isInDnc ? 'Mark DNC' : 'Remove DNC'}
                            textCursor="pointer"
                            icon={
                              <DoDisturbOnIcon
                                sx={{ height: '23', width: '23', color: WsColors.White }}
                              />
                            }
                            textColor={WsTypoColors.PRIMARY}
                            onClick={() => setOpenDNC(!openDNC)}
                          />
                        </ListItemButton>
                      </Grid>
                    </PopoverOnClick>
                  </Grid>
                </Grid>
                <Grid spacing={2}>
                  <WsTypography
                    variant={WsTypoVariants.BODY2}
                    color={WsTypoColors.WHITE}
                    cursor="pointer"
                  >
                    Created on {getFormatDate(clientContactInfo?.createdOn?.toString() ?? '')}
                  </WsTypography>
                </Grid>
              </Grid>
            </Grid>
            <Grid direction="row" justifyContent="space-between" px={1} ml={6} spacing={24}>
              <Grid container rowSpacing={1} py={2}>
                <Grid item xs={4}>
                  <Link
                    component={RouterLink}
                    underline="none"
                    to={`/client-details?tabIndex=0&isProfile=true&isChild=${
                      clientContactInfo.clientId != null ? false : true
                    }&name=${clientContactInfo?.clientName}&clientId=${
                      clientContactInfo.clientId
                    }&breadCrumbList=${getEncodedQueryParams(ClintPageBreadCrumb['CLIENTS'])}`}
                  >
                    <WsIconText
                      icon={<MdOutlineBusiness size={20} color={WsColors.White} />}
                      text={clientContactInfo.clientName || 'Not Available'}
                      textColor={WsTypoColors.PRIMARY}
                      textSize={WsTypoVariants.SUB_TITLE}
                      popOverText="Client"
                      textCursor="pointer"
                    />
                  </Link>
                </Grid>
                <Grid item xs={4}>
                  <WsIconText
                    icon={<MdOutlinePeople size={20} color={WsColors.White} />}
                    text={clientContactInfo.position || 'Not Available'}
                    textColor={WsTypoColors.WHITE}
                    textSize={WsTypoVariants.SUB_TITLE}
                    popOverText="Position"
                    textCursor="pointer"
                  />
                </Grid>
                <Grid item xs={4}>
                  <WsIconText
                    icon={<MdOutlineInfo size={20} color={WsColors.White} />}
                    text={clientContactInfo.emailAddress || 'Not Available'}
                    textColor={WsTypoColors.WHITE}
                    textSize={WsTypoVariants.SUB_TITLE}
                    popOverText="Email Address"
                    textCursor="pointer"
                  />
                </Grid>
                <Grid item xs={4}>
                  <WsIconText
                    icon={<MdOutlinePhone size={20} color={WsColors.White} />}
                    text={clientContactInfo?.phoneNumber || 'Not Available'}
                    textColor={WsTypoColors.WHITE}
                    textSize={WsTypoVariants.SUB_TITLE}
                    popOverText="Phone Number"
                    textCursor="pointer"
                  />
                </Grid>
                <Grid item xs={4}>
                  <WsIconText
                    icon={<MdOutlineLocationOn size={20} color={WsColors.White} />}
                    text={
                      clientContactInfo?.location?.city || clientContactInfo?.location?.country
                        ? `${clientContactInfo?.location?.city ?? ''}, ${
                            clientContactInfo?.location?.country ?? ''
                          }`
                        : 'Not Available'
                    }
                    textColor={WsTypoColors.WHITE}
                    textSize={WsTypoVariants.SUB_TITLE}
                    popOverText="Location"
                    textCursor="pointer"
                  />
                </Grid>
                <Grid item xs={4}>
                  {clientContactInfo?.supervisorName &&
                  !/.*xxxxxx.*/.test(clientContactInfo?.supervisorName) ? (
                    clientContactInfo?.supervisorName ? (
                      <Link
                        component={RouterLink}
                        underline="none"
                        to={`/${
                          clientContactInfo?.supervisor?.id
                        }/client-contact-details?isChild=${isChild}&name=${parentName ?? ''}`}
                      >
                        <WsIconText
                          icon={<PersonIcon sx={{ fontSize: 20, color: WsColors.White }} />}
                          text={clientContactInfo?.supervisorName}
                          textSize={WsTypoVariants.SUB_TITLE}
                          textColor={WsTypoColors.PRIMARY}
                          popOverText="Supervisor Name"
                          textCursor="pointer"
                        />
                      </Link>
                    ) : (
                      <WsIconText
                        icon={<PersonIcon sx={{ fontSize: 20, color: WsColors.White }} />}
                        text="Not Available"
                        textColor={WsTypoColors.WHITE}
                        textSize={WsTypoVariants.SUB_TITLE}
                        popOverText="Supervisor Name"
                      />
                    )
                  ) : (
                    <WsIconText
                      icon={<MdOutlineSource size={20} color={WsColors.White} />}
                      text={clientContactInfo?.supervisorName}
                      textSize={WsTypoVariants.SUB_TITLE}
                      textColor={WsTypoColors.PRIMARY}
                      popOverText="Supervisor Name"
                    />
                  )}
                </Grid>
                <Grid item xs={4}>
                  <WsIconText
                    icon={<PersonIcon sx={{ fontSize: 20, color: WsColors.White }} />}
                    text={clientContactInfo?.owner?.name || 'Not Available'}
                    textColor={WsTypoColors.WHITE}
                    textSize={WsTypoVariants.SUB_TITLE}
                    popOverText="Owner"
                    textCursor="pointer"
                    onClick={() =>
                      clientContactInfo?.owner &&
                      openUrlInNewTab(
                        `/users/details-page?email=${clientContactInfo?.owner?.email}&isLink=true&isUserAnalytics=true`
                      )
                    }
                  />
                </Grid>

                {isInDnc && (
                  <>
                    <Grid item xs={4}>
                      <WsIconText
                        icon={<CalendarTodayIcon sx={{ fontSize: 20, color: WsColors.White }} />}
                        text={
                          clientContactInfo?.dncDetails?.dncEndDate
                            ? new Date(clientContactInfo.dncDetails.dncEndDate).toLocaleDateString(
                                'en-GB'
                              )
                            : 'Not Available'
                        }
                        textColor={WsTypoColors.WHITE}
                        textSize={WsTypoVariants.SUB_TITLE}
                        popOverText="DNC Upto"
                        textCursor="pointer"
                      />
                    </Grid>
                    <Grid item>
                      <WsIconText
                        icon={<CommentIcon sx={{ fontSize: 20, color: WsColors.White }} />}
                        text={clientContactInfo?.dncDetails?.notes || 'Not Available'}
                        textColor={WsTypoColors.WHITE}
                        textSize={WsTypoVariants.SUB_TITLE}
                        popOverText="DNC Comment"
                        textCursor="pointer"
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
            {clientContactInfo?.tags && (
              <Grid container direction="row" spacing={2} pl={6}>
                <CandidateTags tags={clientContactInfo?.tags ?? []} initialLimit={5} />
              </Grid>
            )}
          </Card>
          {openDNC && clientContactInfo && (
            <WsDrawer open={openDNC} onClose={() => setOpenDNC(!openDNC)}>
              <DataPrivacy
                email={clientContactInfo?.emailAddress ?? ''}
                candidateName={clientContactInfo.createdByName ?? ''}
                isInDnc={isInDnc ?? false}
                dncDetails={clientContactInfo?.dncDetails}
                privacyOptions={limitedPrivacyOptions}
                restrictLabel="DNC Up to*"
                entityId={(clientContactInfo?.id as string) ?? ''}
                parentEntitiyId={(clientContactInfo?.clientId as string) ?? ''}
                entityName={clientContactInfo?.firstName}
                logContextType={LogContextType.Client}
                onSubmitApi={(data) => handleDncSubmit(clientContactInfo?.id as string, data)}
                enableActivityLog={true}
              />
            </WsDrawer>
          )}
          <Grid item borderRadius={2} sx={{ background: WsColors.White }} mt={2} mb={1}>
            <ScrollableButtonTabs
              scrollList={clientContactLayoutTabNames()}
              getTabIndex={handleTabIndexChange}
              defaultValue={parentTabIndex}
            />
          </Grid>
          {parentTabIndex == 0 &&
            (isAuthorizedViewAnalytics ? (
              <ComposableDashboardFiltersContextProvider>
                <UserProfileOverview
                  clientSpocEmail={clientContactInfo.emailAddress}
                  clientContactIds={[clientContactInfo.id ?? '']}
                />
              </ComposableDashboardFiltersContextProvider>
            ) : (
              <AccessControl errorText="You don't have access to view the client contact data" />
            ))}

          {parentTabIndex == 1 && (
            <WsTabs
              onChange={(index) =>
                notesAmplitudeEvents(
                  index == 0 ? 'contact_details_notes' : 'contact_details_activities',
                  'Contact Details',
                  workspace
                )
              }
            >
              <WsTabs.Item label="Notes">
                <ComposeNote
                  parent={NotesParent.CLIENTCONTACT}
                  parentId={clientContactInfo?.clientId}
                  isClient={false}
                  clientContactId={clientContactInfo?.id ?? ''}
                />
              </WsTabs.Item>

              <WsTabs.Item label="Activities">
                {getActivityData && (
                  <Grid item xs={12} borderRadius={2} sx={{ background: WsColors.White }}>
                    <Box ml="-97%">
                      <WsTimeLine activityList={activityLists} timeLineDotVariant={'outlined'} />
                    </Box>
                  </Grid>
                )}
              </WsTabs.Item>
            </WsTabs>
          )}

          {parentTabIndex == 2 && (
            <DocumentsTab
              clientId={clientContactInfo?.clientId ?? ''}
              clientContactId={clientContactInfo.id ?? ''}
              clientName={parentName ?? ''}
              entityType="contact"
            />
          )}
        </Box>
      )}
      {openClientOwnerFormDialog && clientContactInfo?.id && (
        <ClientOwnerPopUp
          id={clientContactInfo?.id ?? ''}
          entityType="contact"
          clientOwner={clientContactInfo.owner || null}
          open={openClientOwnerFormDialog}
          onCancel={() => {
            setOpenClientOwnerFormDialog(false);
          }}
          onClientContactSave={(updatedContact: ClientContactDTO) => {
            setClientContactInfo(updatedContact);
            setOpenClientOwnerFormDialog(false);
          }}
        />
      )}
    </>
  );
};

export default ClientContactDetails;
